export default __webpack_public_path__ + "static/media/king_of_pentacles.7af93cda.png";